export default __webpack_public_path__ + "968461ea92d10d944dff4b37c2fb5c05.ico";